import { useFormik } from "formik";
import TextInput from "../../../components/inputs/textInput";
import Button from "../../../components/buttons/button";
import { useTranslation } from "react-i18next";

const CubicMeterCalculator = () => {
  const formik = useFormik({
    initialValues: {
      parcels: "",
      length: "",
      width: "",
      height: "",
    },
    onSubmit: (values) => {
      const { length, width, height, parcels } = values;

      const l = parseFloat(length);
      const w = parseFloat(width);
      const h = parseFloat(height);
      const p = parseInt(parcels);

      if (!isNaN(l) && !isNaN(w) && !isNaN(h) && !isNaN(p)) {
        const volumePerParcel = (l * w * h) / 1000000;
        const totalVolume = volumePerParcel * p;

        formik.setFieldValue("totalVolume", totalVolume.toFixed(3));
      } else {
        formik.setFieldValue("totalVolume", "Invalid input");
      }
    },
  });
  const { t } = useTranslation();
  return (
    <article className="p-4 bg-white rounded-2xl shadow-mainShadow">
      <h3 className="text-xl font-bold text-center text-mainBlue">
        {t("cubicMeterCalculator")}
      </h3>
      <p className="my-5 text-lg font-bold text-center text-mainGray">
        {t("useTheCubicMeter")}
      </p>
      <form onSubmit={formik.handleSubmit}>
        <div className="inputs">
          <TextInput
            label={t("lengthCM-")}
            formik={formik}
            name={"length"}
            placeholder={""}
            number
          />
          <TextInput
            label={t("widthCM-")}
            formik={formik}
            name={"width"}
            placeholder={""}
            number
          />
          <TextInput
            label={t("heightCM-")}
            formik={formik}
            name={"height"}
            placeholder={""}
            number
          />
        </div>
        <TextInput
          label={t("numberOfParcels")}
          formik={formik}
          name={"parcels"}
          placeholder={""}
          number
        />
        <Button text={t("calculateParcelSize")} className={"w-full bg-mainRed my-4"} />
        <TextInput
          label={t("totalVolumeM")}
          formik={formik}
          name={"totalVolume"}
          placeholder={""}
          disabled
        />
      </form>
    </article>
  );
};

export default CubicMeterCalculator;
